import React from 'react';
import './StoreLocator.css';
import { Facebook} from 'react-spinners-css';
import { useGeolocation } from '../../hooks/useGeolocation';
import { StoreElige } from './StoreElige';
import { StoreUbicacion } from './StoreUbicacion';

export const StoreLocator = () => {

    
     const {loaded, coordinates, error} = useGeolocation();

    
    return (
        <>
        
        { loaded
            ? error ? <StoreElige/> : <StoreUbicacion valor={coordinates}/> 
            : <div className="spinner"><Facebook color="#594498"/></div>
            
        }


        </>

    )
}
